import styled, { keyframes } from "styled-components";

export const Label = styled.label`
	width: 100%;
	display: inline-block;
	padding: 28px;
	box-sizing: border-box;

	font-size: calc(8px + 1vw);
	font-weight: 400;
	letter-spacing: 0.02em;
	text-align: left;
	cursor: pointer;

	outline: none;
	border-radius: 30px;
	background-color: #F7F7F7;
	border: ${(props) => (props.error ? "1px solid darkred" : "none")};

	position: relative;

    & > .placeholder {
        color: ${(props) => props.error && "darkred"};
		opacity: ${(props) => props.error ? 1 : 0.54};
    }
	
	& > img {
		position: absolute;
		width: calc(9px + 1.08vw);
		right: 28px;
	}

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    &[type=number] {
        -moz-appearance: textfield;
    }

	@media screen and (max-width: 992px) {
		font-size: 12px;
		line-height: 14px;
		border-radius: 16px;
		padding: 16px;

		& > img{
			right: 16px;
			width: 13px;
		}
	}

	@media screen and (min-width: 992px) and (max-width: 1200px) {
		padding: 20px;

		& > img {
			right: 20px;
		}
	}

	@media screen and (min-width: 1600px) {
		font-size: 24px;

		& > img{
			width: 26px;
		}
	}
`

export const Input = styled.input`
	display: none;
`;